<template>
  <i class="lpIconfont" :class="icon" @click="handleIconClick"></i>
</template>

<script>
export default {
  name: "Icon",
  props: {
    icon: String,
  },
  methods: {
    handleIconClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less" scoped></style>
